import { isBrowser } from "../../utils/browser"

export const withoutClientHydration =
    <C, P extends object>(getInitialProps: (context: C) => Promise<P>) =>
    async (context: C): Promise<P> => {
        const props = await getInitialProps(context)
        if (!isBrowser) {
            return props
        }
        const { initialState: _initialState, ...rest } = props as P & { initialState?: unknown }
        return rest as P
    }
